import React from "react";

const ShoeBanner = () => {
  return (
    <section className="shoe-banner-section py-[200px] bg-[#00FF7F] flex items-center justify-center">
      <div className="text-center">
        <h1
          className="text-[390px] leading-[60px] tracking-[0.1em] uppercase"
          style={{ fontFamily: "Inter", fontWeight: 400 }}
        >
          ARTS
        </h1>
      </div>
    </section>
  );
};

export default ShoeBanner;
